/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DepositoInformacionAdicionalModeloMLS } from './depositoInformacionAdicionalModeloMLS';

export interface ObtenerInformacionAdicionalDepositoMS { 
    oficina?: string;
    producto?: string;
    dpfEndosado?: string;
    fechaCreacion?: Date;
    tasaTotal?: number;
    componentesDeposito?: Array<DepositoInformacionAdicionalModeloMLS>;
    pagoPeriodicoInteres?: boolean;
    tasa?: number;
    variacionTasa?: number;
    plazoDias?: number;
    tea?: number;
    valorImpuesto?: number;
    totalRecibir?: number;
}